import { Warning } from '@mui/icons-material';

import './PageNotFoundAuthed.css';
import PageNotFoundCard from './PageNotFoundCard';
import { useGetStudioHomeRoute } from 'Routing/index';
import { PodManagementHomeRoute, TowerHomeRoute } from 'Routing/RouteConstants';
import { PAGE_NOT_FOUND_AUTHED_TEXT } from './PageNotFoundAuthed.constants';
import { ShowComponentIfUserHasPermission } from 'RBAC/index';
import TabBar from '@3.0/Layouts/TabbedLayout/TabBar/TabBar';

type TProps = {
  hideTabBar?: boolean;
};

const PageNotFoundAuthed = ({ hideTabBar = false }: TProps) => {
  const studioPath = useGetStudioHomeRoute();

  return (
    <section data-testid="page-not-found-authed">
      {!hideTabBar && <TabBar links={[]} />}
      <section className="tw:text-center tw:mt-10 page-not-found-authed">
        <Warning
          className="tw:mx-auto tw:text-status-warning tw:text-7xl! tw:h-[72px] tw:w-[72px]"
          fontSize="inherit"
        />
        <p className="tw:text-3xl tw:mb-3 tw:pt-1">{PAGE_NOT_FOUND_AUTHED_TEXT.title}</p>
        <div className="tw:text-lg">{PAGE_NOT_FOUND_AUTHED_TEXT.description}</div>

        <ShowComponentIfUserHasPermission
          allowAny
          permissionRef={[
            ...PAGE_NOT_FOUND_AUTHED_TEXT.cards.studio.permissionRef,
            ...PAGE_NOT_FOUND_AUTHED_TEXT.cards.cloudAdmin.permissionRef,
          ]}
        >
          <div className="page-not-found-authed-container">
            <div className="tw:bg-secondary-500 tw:h-10"></div>
            <div className="tw:text-3xl tw:mb-3 tw:p-6 tw:text-left">
              {PAGE_NOT_FOUND_AUTHED_TEXT.chooseOption}
            </div>
            <div className="tw:flex tw:flex-wrap tw:gap-10 tw:justify-center">
              <ShowComponentIfUserHasPermission
                allowAny
                permissionRef={PAGE_NOT_FOUND_AUTHED_TEXT.cards.studio.permissionRef}
              >
                <PageNotFoundCard
                  label={PAGE_NOT_FOUND_AUTHED_TEXT.cards.studio.label}
                  info={PAGE_NOT_FOUND_AUTHED_TEXT.cards.studio.info}
                  to={studioPath}
                />
                <PageNotFoundCard
                  label={PAGE_NOT_FOUND_AUTHED_TEXT.cards.tower.label}
                  info={PAGE_NOT_FOUND_AUTHED_TEXT.cards.tower.info}
                  to={TowerHomeRoute}
                />
              </ShowComponentIfUserHasPermission>

              <ShowComponentIfUserHasPermission
                allowAny
                permissionRef={PAGE_NOT_FOUND_AUTHED_TEXT.cards.cloudAdmin.permissionRef}
              >
                <PageNotFoundCard
                  label={PAGE_NOT_FOUND_AUTHED_TEXT.cards.cloudAdmin.label}
                  info={PAGE_NOT_FOUND_AUTHED_TEXT.cards.cloudAdmin.info}
                  to={PodManagementHomeRoute}
                />
              </ShowComponentIfUserHasPermission>
            </div>
          </div>
        </ShowComponentIfUserHasPermission>
        <p className="tw:mt-6 tw:text-lg">{PAGE_NOT_FOUND_AUTHED_TEXT.contactAdmin}</p>
      </section>
    </section>
  );
};

export default PageNotFoundAuthed;
